import React from "react";
import "./LabBanner.css";
import { BarChart3 } from "lucide-react"; // icon
import { useNavigate } from "react-router-dom";
const LabBanner = () => {


  const navigate = useNavigate();


  return (
    <section className="labBanner">
      <div className="labOverlay">

        {/* Left icon + text */}
        <div className="labLeft">
          <div className="labIcon">
            <BarChart3 size={50} strokeWidth={1.5}/>
          </div>
          <div>
            <p className="smallText">Solutions spotlight</p>
          </div>
        </div>

        {/* Center content */}
        <div className="labCenter">
          <h2> Reminded for every skin, everywhere</h2>
          <p>Professional skincare treatments with modern technology & fast visible results</p>
        </div>

        {/* Button */}



<div className="labRight">
  <button 
    className="labBtn"
    onClick={() => navigate("/skin-care")}
  >
    Explore Products
  </button>
</div>
        {/* <div className="labRight">
       
          <button className="labBtn">Explore Products</button>
          

        </div> */}

      </div>
    </section>
  );
};

export default LabBanner;
